// lang-en.ts

export const LANG_KN_NAME = 'kn';

export const LANG_KN_TRANS = {
    'Family':'ಕುಟುಂಬ',
    'User Name': 'ಬಳಕೆದಾರ ಹೆಸರು',
    'Username': 'ಬಳಕೆದಾರ',
    'User': 'ಬಳಕೆದಾರ',
    'Add Phone Number':' ಫೋನ್ ಸಂಖ್ಯೆ ಸೇರಿಸಿ',
    'Phone Number':'ದೂರವಾಣಿ ಸಂಖ್ಯೆ',
    'All Users': 'ಎಲ್ಲಾ ಬಳಕೆದಾರರು',
    'Password': 'ಪಾಸ್ವರ್ಡ್',
    'LOG IN': 'ಲಾಗ್ ಇನ್ ಮಾಡಿ',
    'Role': 'ಪಾತ್ರ',
    'Vazipadu': 'ವಜೀಪದು',
    'Vazhipadu': 'ವಜೀಪದು',
    'Pooja': 'ಪೂಜೆ',
    'Deity': 'ದೇವತೆ',
    'Avakasi':'ಉತ್ತರಾಧಿಕಾರಿ',
    'Vihitham':'ಹಂಚು',
    'Category': 'ವರ್ಗ',
    'Code': 'ಸಂಕೇತಗಳು',
    'Description': 'ವಿವರಣೆ',
    'Properties': 'ಗುಣಮಟ್ಟ',
    'Name': 'ಹೆಸರು',
    'HOME': 'ಹೋಮ್ ಪುಟ',
    'Update Stock': 'ಅಪ್ಡೇಟ್ ಸ್ಟಾಕ್',
    'Administration': 'ಆಡಳಿತ',
    'Account': 'ಖಾತೆ',
    'Head': 'ಹೆಡ್',
    'Qty': 'ಪ್ರಮಾಣ ',
    'Edit':'ಸಂಪಾದಿಸಿ',
    'Auditorium Enquiry Edit': 'ಆಡಿಟೋರಿಯಂ ವಿಚಾರಣೆ ಬದಲಾಯಿಸಿ',
    'Auditorium Enquiry View': 'ಆಡಿಟೋರಿಯಂ ವಿಚಾರಣೆ ನೋಟ',
    'Personal Id Pooja Report': 'ವೈಯಕ್ತಿಕ ಐಡಿ ಪೂಜಾ ವರದಿ',
    'Registered Devotee Pooja Report': 'ನೋಂದಾಯಿತ ಭಕ್ತ ಪೂಜಾ ವರದಿ',
    'Add Personal Devotee': 'ವೈಯಕ್ತಿಕ ಭಕ್ತರನ್ನು ಸೇರಿಸಿ',
    'Add Devotee': 'ಭಕ್ತರನ್ನು ಸೇರಿಸಿ',
    'Personal': 'ವೈಯಕ್ತಿಕ',
    'Account Head': 'ಖಾತೆ ಹೆಡ್',
    'Access Rights': 'ಪ್ರವೇಶ ಹಕ್ಕುಗಳು',
    'Cheque Enquiry': 'ವಿಚಾರಣೆ ಪರಿಶೀಲಿಸಿ',
    'Add User': 'ಬಳಕೆದಾರರನ್ನು ಸೇರಿಸಿ ',
    'Account Balance': 'ಖಾತೆ ಬ್ಯಾಲೆನ್ಸ್',
    'Vazhipadu Head': 'ವಜೀಪದು',
    'Vendor / Customer': 'ಮಾರಾಟಗಾರ / ಗ್ರಾಹಕ',
    'Vendor': 'ಮಾರಾಟಗಾರ',
    'Auto Back Up':'ಆಟೋ ಬ್ಯಾಕ್ ಅಪ್',
    'Customer': 'ಗ್ರಾಹಕರು',
    'Avakasi Vihitham':'ಪೂಜಾ ಪಾಲು',
    'Employees': 'ನೌಕರರು',
    'Employee': 'ಉದ್ಯೋಗಿ',
    'Product': 'ಉತ್ಪನ್ನ',
    'Per Pooja Items Report':'ಪ್ರತಿ ಪೂಜಾ ಐಟಂಗಳ ವರದಿ്',
    'Products': 'ಉತ್ಪನ್ನಗಳು',
    'Vazhipad': 'ಪೂಜಾ',
    'Expense': 'ಖರ್ಚು',
    'Detailed': 'ವಿವರಿಸಲಾಗಿದೆ',
    'No data available': 'ಯಾವುದೇ ಮಾಹಿತಿ ಇಲ್ಲ',
    'Statement': 'ಹೇಳಿಕೆ',
    'Bank': 'ಬ್ಯಾಂಕ್',
    'Add': 'ಸೇರಿಸಿ',
    'Nadavaravu': 'ಚಿನ್ನ ಮತ್ತು ಸಿಲ್ವರ್ ಆದಾಯ',
    'Store Transfer': 'ಸಂಗ್ರಹಣೆ ವರ್ಗಾವಣೆ',
    'Transfer': 'Transfer',
    'List': 'ವರ್ಗಾವಣೆ',
    'Pass': 'ಉತ್ತೀರ್ಣ',
    'Member': 'ಸದಸ್ಯ',
    'Member Heads':'ಸದಸ್ಯ ಮುಖ್ಯಸ್ಥರು',
    'Members': 'ಸದಸ್ಯ ಪಟ್ಟಿ',
    'Membership': 'ಸದಸ್ಯತ್ವ',
    'Auditorium': 'ಸಭಾಂಗಣ',
    'Auditorium Report': 'ಸಭಾಂಗಣ ವರದಿ',
    'Enquiry': 'Enquiry',
    // 'Pooja': 'ಪುಜಾ',
    'edit product': 'ಉತ್ಪನ್ನ ಸಂಪಾದಿಸಿ',
    'add product': 'ಉತ್ಪನ್ನ ಸೇರಿಸಿ',
    'Date Of Birth': 'ಹುಟ್ತಿದ ದಿನ',
    'Pooja Enquiry': 'ಪೂಜಾ ವಿಚಾರಣೆ',
    'Reports': 'ವರದಿಗಳು',
    'Audit': 'ಆಡಿಟ್',
    'Pooja Report': 'ಪೂಜಾ ವರದಿ',
    'Star Wise Pooja Report': 'ಸ್ಟಾರ್ ವೈಸ್ ಪೂಜಾ ವರದಿ',
    'Report': 'ವರದಿ',
    'Bank Statement Report': 'ಬ್ಯಾಂಕ್ ಲೆಕ್ಕವಿವರಣೆ്',
    'Current Stock Report': 'ಪ್ರಸ್ತುತ ಸ್ಟಾಕ್ ವರದಿ',
    'Membership Report': 'ಸದಸ್ಯತ್ವ ವರದಿ',
    'Nadavaravu Report': 'ಚಿನ್ನ ಮತ್ತು ಸಿಲ್ವರ್ ಆದಾಯ ವರದಿ',
    'Stock Report': 'ಸ್ಟಾಕ್ ವರದಿ',
    'POS Report':'ಪಿಓಎಸ್ ವರದಿ',
    'Stock': 'ಸ್ಟಾಕ್',
    'Income & Expense Report': 'ಆದಾಯ ಮತ್ತು ಖರ್ಚು ವರದಿ',
    'Expense Report': 'ಖರ್ಚು ವರದಿ',
    'Cheque Clearance Report': 'ಕ್ಲಿಯರೆನ್ಸ್ ಪರಿಶೀಲಿಸಿ ವರದಿ',
    'Cheque Report':'ಪರಿಶೀಲಿಸಿ ವರದಿ',
    'Payment Payable': 'ಪಾವತಿಸಲಾಗುವುದು',
    'Payment Receivable': 'ಪಾವತಿ ಸ್ವೀಕಾರಾರ್ಹ',
    'Cancelled Transaction': 'ರದ್ದುಪಡಿಸಿದ ವಹಿವಾಟು',
    'Income Collection': 'ಆದಾಯ ಸಂಗ್ರಹಣೆ',
    'Collection Report': 'ಸಂಗ್ರಹಣೆ ವರದಿ',
    'Collection': 'ಸಂಗ್ರಹಣೆ',
    'Pooja Collection':'ಪೂಜಾ ಸಂಗ್ರಹಣೆ',
    'Pooja List':'ಭವಿಷ್ಯದ ಪೂಜಾ ಪಟ್ಟಿ',
    'Store Pass Report': 'ಅಂಗಡಿ ಪಾಸ್ ವರದಿ',
    'Store Pass': 'ಅಂಗಡಿ ಪಾಸ್',
    'Transaction': 'ವ್ಯವಹಾರ',
    'Purpose': 'ಉದ್ದೇಶ',
    'Type': 'ಮಾದರಿ',
    'Period': 'ಅವಧಿ',
    'Invoice': 'ಸರಕುಪಟ್ಟಿ',
    'Bill': 'ಬಿಲ್',
    'Create Bill': 'ಬಿಲ್ ರಚಿಸಿ',
    'Create Invoice': 'ಸರಕುಪಟ್ಟಿ ರಚಿಸಿ',
    'Invoice Number': 'ಸರಕುಪಟ್ಟಿ',
    'Invoice At': 'ಸರಕುಪಟ್ಟಿ ದಿನ',
    'Cleared At': 'ಕ್ಲಿಯರೆನ್ಸ್ ಪರಿಶೀಲಿಸಿ ದಿನ',  
    'Cheque': 'ಪರಿಶೀಲಿಸಿ',
    'Cheque No': 'ಪರಿಶೀಲಿಸಿ ಸಂಖ್ಯೆ',
    'cash/cheque': 'ನಗದು / ಚೆಕ್ ',
    'cash/cheque/pos':'ನಗದು / ಚೆಕ್ / ಪೋಸ್',
    'Devotee': 'ಭಕ್ತರು',
    'Star': 'ಸ್ಟಾರ್',
    'Unit': 'ಘಟಕ',
    'Material': 'ವಸ್ತು',
    'Pooja Date': 'ಪೂಜಾ ದಿನ',
    'Quantity': 'ಪ್ರಮಾಣ',
    'quantity': 'ಪ್ರಮಾಣ',
    'Amount': 'ಮೊತ್ತ',
    'Cost': 'ಮೊತ್ತ',
    'Paid': 'ಪಾವತಿಸಲಾಗಿದೆ',
    'Paid Amount': 'ಪಾವತಿಸಲಾಗಿದೆ ಮೊತ್ತ',
    'Due': 'ಕಾರಣ',
    'Total': 'ಒಟ್ಟು',
    'Devotee name': 'ಭಕ್ತರ ಹೆಸರು',
    'Devotee Name': 'ಭಕ್ತರ ಹೆಸರು',
    'Collecting Person': 'ವ್ಯಕ್ತಿಯನ್ನು ಸಂಗ್ರಹಿಸುವುದು',
    'Opening': 'ತೆರೆಯಲಾಗುತ್ತಿದೆ',
    'Incoming': 'ಒಳಬರುವ',
    'Outgoing': 'ಹೊರಹೋಗುವಿಕೆ',
    'Closing': 'ಮುಚ್ಚುವುದು',
    'is required': 'ಅಗತ್ಯ',
    'Date': 'ದಿನ',
    'diety': 'ದೇವತೆ',
    'Diety': 'ದೇವತೆ',
    'Prathishta': 'ದೇವತೆ',
    'Choose Star': 'ಸ್ಟಾರ್',
    'Choose Vazipadu': 'ಪೂಜಾ ಆಯ್ಕೆಮಾಡಿ',
    'name': 'ಹೆಸರು',
    'Invalid': 'ಅಮಾನ್ಯವಾಗಿದೆ',
    'Address': 'ವಿಳಾಸ',
    'Email': 'ಇಮೇಲ್',
    'Advance': 'ಅಡ್ವಾನ್ಸ್',
    'Balance': 'ಸಮತೋಲನ',
    'Phone': 'ದೂರವಾಣಿ',
    'phone': 'ದೂರವಾಣಿ',
    'Submit': 'ಸಲ್ಲಿಸಲು',
    'submit': 'ಸಲ್ಲಿಸಲು',
    'Remove': 'ತೆಗೆದುಹಾಕಿ',
    'Both': 'ಎರಡೂ',
    'Trancastion': 'ವಹಿವಾಟು',
    'type': 'ಕೌಟುಂಬಿಕತೆ',
    'CASH': 'ನಗದು',
    'CHEQUE': 'ಪರಿಶೀಲಿಸಿ',
    'Status': 'ಸ್ಥಿತಿ',
    'Continuous Booking': 'ನಿರಂತರ ಬುಕಿಂಗ್',
    'Booking': 'ಬುಕಿಂಗ್',
    'days': 'ದಿನಾಂಕಗಳು',
    'Available': 'ಲಭ್ಯವಿದೆ',
    'From Date': 'ದಿನಾಂಕದಿಂದ',
    'To Date': 'ದಿನಾಂಕಕ್ಕೆ',
    'must be greater than From Date': 'ದಿನಾಂಕದಿಂದ ಹೆಚ್ಚಿರಬೇಕು',
    'must be lesser than To Date': 'ದಿನಾಂಕಕ್ಕಿಂತ ಕಡಿಮೆ ಇರಬೇಕು',
    'Selected days': 'ಆಯ್ಕೆ ಮಾಡಿದ ದಿನಾಂಕಗಳ ಸಂಖ್ಯೆ',
    'All': 'ಎಲ್ಲ',
    'Month': 'ತಿಂಗಳು',
    'Thithi': 'ತಿಥಿ',
    'Week': 'ವಾರ',
    'Cancel': 'ರದ್ದುಮಾಡಿ',
    'cancel': 'ರದ್ದುಮಾಡಿ',
    'number': 'ಸಂಖ್ಯೆ',
    'Number': 'ಸಂಖ್ಯೆ',
    'No:': 'ಸಂಖ್ಯೆ:',
    'Billed Person Name': 'ಬಿಲ್ಡ್ ಪರ್ಸನ್ ಹೆಸರು',
    'Book': 'ಬುಕಿಂಗ್',
    'Billing Devotee': 'ಬಿಲ್ಲಿಂಗ್ ಭಕ್ತಾಧಿ',
    'Billing': 'ಬಿಲ್ಲಿಂಗ್',
    'Issued Store': 'ನೀಡಿತು ಅಂಗಡಿ',
    'Choose Store': 'ಅಂಗಡಿ ಆಯ್ಕೆಮಾಡಿ',
    'Store': 'ಸ೦ಗ್ರಹ',
    'No Store': 'ಯಾವುದೇ ಸಂಗ್ರಹಣೆ ಇಲ್ಲ',
    'Personal Pooja': 'ವೈಯಕ್ತಿಕ ಪೂಜಾ',
    'SAMARPANAM': 'ಹಣವಿಲ್ಲದ ದೇಣಿಗೆಗಳು',
    'Samarpanam': 'ಹಣವಿಲ್ಲದ ದೇಣಿಗೆಗಳು',
    'NADAVARAVU': 'ಹಣವಿಲ್ಲದ ದೇಣಿಗೆಗಳು',
    'Pooja Stall': 'ಪೂಜಾ ಸ್ಟಾಲ್',
    'Pooja Booking': 'ಪೂಜಾ ಬುಕಿಂಗ್',
    'STOCK REDUCING': 'ಸಂಗ್ರಹ ಕಡಿಮೆ',
    'Saleable': 'ಸಂಬಳ',
    'Rate': 'ಬೆಲೆ',
    'Choose Item': 'ಐಟಂ ಆಯ್ಕೆಮಾಡಿ',
    'Issued Item': 'ನೀಡಿರುವ ಐಟಂ',
    'Item': 'ವಸ್ತು',
    'Issued': 'ಕೊಡಲಾಗಿದೆ',
    'Entered quantity is out off current quantity': 'ನಮೂದಿಸಲಾದ ಪ್ರಮಾಣವು ಪ್ರಸ್ತುತ ಪ್ರಮಾಣವನ್ನು ಮೀರಿದೆ',
    'Recieved': 'ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
    'Please choose any one of the above item': 'ದಯವಿಟ್ಟು ಮೇಲಿನ ಐಟಂಗಳಲ್ಲಿ ಯಾವುದಾದರೂ ಒಂದನ್ನು ಆರಿಸಿ',
    // 'Add': 'ಸೇರಿಸಿ',
    'Thulabharam': 'ತುಲಭಾರಂ',
    'You can\'t book this pooja for today': 'ಈ ಪೂಜೆಯನ್ನು ನೀವು ಇಂದು ಬುಕ್ ಮಾಡಲಾಗುವುದಿಲ್ಲ',
    'You can\'t book this pooja for tomorrow': 'ನಾಳೆ ಈ ಪೂಜೆಯನ್ನು ನೀವು ಬುಕ್ ಮಾಡಲಾಗುವುದಿಲ್ಲ',
    'Warning': 'ಎಚ್ಚರಿಕೆ',
    'Please change booking date': 'ದಯವಿಟ್ಟು ಬುಕಿಂಗ್ ದಿನಾಂಕವನ್ನು ಬದಲಿಸಿ',
    'Limit exceeded': 'ಮಿತಿ ಮೀರಿದೆ',
    'Anyway': 'ಹೇಗಾದರೂ',
    'continue?': 'ಮು೦ದುವರೆಸು?',
    'No stock available': 'ಯಾವುದೇ ಸ್ಟಾಕ್ ಲಭ್ಯವಿಲ್ಲ',
    'Limit exceeded to book this pooja': 'ಈ ಪೂಜೆಯನ್ನು ಬುಕಿಂಗ್ ಮಾಡಲು ಮಿತಿ ಮೀರಿದೆ',
    'Can add multiple devotees': 'ಬಹು ಭಕ್ತರನ್ನು ಸೇರಿಸಬಹುದು',
    'Print': 'ಮುದ್ರಿಸಿ',
    'Salary': 'ವೇತನ',
    'Booking on': 'ಬುಕಿಂಗ್ ಆನ್',
    'Timing': 'ಸಮಯ',
    'Forenoon': 'ಬೆಳಿಗ್ಗೆ',
    'Afternoon': 'ಮಧ್ಯಾಹ್ನ',
    'Full Day': 'ಪೂರ್ಣ ದಿನ',
    'Temple': 'ದೇವಾಲಯ',
    'Postage': 'ಪೋಸ್ಟೇಜ್',
    'Confirm your postage address': 'ನಿಮ್ಮ ಅಂಚೆ ವಿಳಾಸವನ್ನು ದೃಢೀಕರಿಸಿ',
    'Same for all devotee': 'ಎಲ್ಲಾ ಭಕ್ತರಿಗೆ ಒಂದೇ',
    'Add devotee address': 'ಭಕ್ತರ ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ',
    'Edit devotee address': 'ಭಕ್ತರ ವಿಳಾಸವನ್ನು ಸಂಪಾದಿಸಿ',
    'Logo': 'ಲೋಗೋ',
    'Counter': 'ಕೌಂಟರ್',
    'Receipt': 'ಸರಕುಪಟ್ಟಿ',
    'Rows': 'ಸಾಲುಗಳು',
    'Keyboard': 'ಕೀಬೋರ್ಡ್',
    'License Expiry': 'ಪರವಾನಗಿ ಮುಕ್ತಾಯ',
    'Financial Year': 'ಹಣಕಾಸು ವರ್ಷ',
    'Basic': 'ಮೂಲಭೂತ',
    'Advanced': 'ಸುಧಾರಿತ',
    'Settings': 'ಸೆಟ್ಟಿಂಗ್ಗಳು',
    'Printer': 'ಮುದ್ರಣಕಾರ', 
    'Action': 'ಕ್ರಿಯೆ',
    'Payment': 'ಪಾವತಿ',
    'Create Payment': 'ಪಾವತಿ ರಚಿಸಿ',
    'Method': 'ಪದ್ದತಿ',
    'Template': 'ಟೆಂಪ್ಲೇಟು',
    'Old': 'ಹಳೆಯದು',
    'New': 'ಹೊಸ',
    'Change': 'ಬದಲಿಸಿ',
    'Change Password': 'ಗುಪ್ತಪದವನ್ನು ಬದಲಿಸಿ',
    'Is Metal': 'ಮೆಟಲ್',
    'Metal': 'ಮೆಟಲ್',
    'Default': 'ಡೀಫಾಲ್ಟ್',
    'Booked On': 'ಬುಕಿಂಗ್ ಆನ್',
    'Time': 'ಸಮಯ',
    'Income': 'ಹುಟ್ಟುವಳಿ',
    'General Ledger': 'ಸಾಮಾನ್ಯ ಕಡತ',
    'Help': 'ಸಹಾಯ',
    'Welcome': 'ಸ್ವಾಗತ',
    'STODA Editor': ' ಸಂಪಾದಕ',
    'Manual Backup': 'ಮ್ಯಾನುಯಲ್ ಬ್ಯಾಕಪ್',
    'Documentation': 'ದಾಖಲೆ',
    'Keyboard Shortcuts': 'ಕೀಬೋರ್ಡ್ ಶಾರ್ಟ್ಕಟ್ಗಳು',
    'View License': 'ಪರವಾನಗಿ ವೀಕ್ಷಿಸಿ',
    'Feature Request': 'ಫೀಚರ್ ವಿನಂತಿ',
    'Report Issue': 'ಸಮಸ್ಯೆಯನ್ನು ವರದಿ ಮಾಡಿ',
    'Privacy Statement': 'ಖಾಸಗಿ ಹೇಳಿಕೆ',
    'Install Update': 'ನವೀಕರಣವನ್ನು ಸ್ಥಾಪಿಸಿ',
    'Privileges': 'ಸೌಲಭ್ಯಗಳು',
    'Packaged Pooja': 'ಪ್ಯಾಕ್ಡ್ ಪೂಜಾ',
    'Add New ': 'ಹೊಸದನ್ನು ಸೇರಿಸಿ',
    'Add Packaged Pooja': 'ಪ್ಯಾಕೇಜ್ಡ್ ಪೂಜೆಯನ್ನು ಸೇರಿಸಿ',
    'Edit Packaged Pooja': 'ಪ್ಯಾಕೇಜ್ ಮಾಡಲಾದ ಪೂಜಾವನ್ನು ಸಂಪಾದಿಸಿ',
    'Save': 'ಉಳಿಸಿ',
    'Update': 'ನವೀಕರಿಸಿ',
    'Number Of Devotees': 'ಭಕ್ತರ ಸಂಖ್ಯೆ',
    'Exclude Today': 'ಇಂದು ಹೊರತುಪಡಿಸಿ',
    'Number Of Days': 'ದಿನಗಳ ಸಂಖ್ಯೆ',
    'Choose Thithi': 'ತಿಥಿ ಆಯ್ಕೆಮಾಡಿ',
    'Invoice Total': 'ತಿಥಿ ಆಯ್ಕೆಮಾಡಿ',
    'Invoice Received [Cash]': 'ಸರಕುಪಟ್ಟಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ [ನಗದು]',
    'Invoice Received [Bank]': 'ಸರಕುಪಟ್ಟಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ [ಬ್ಯಾಂಕ್]',
    'Receivable Invoice': 'ಸ್ವೀಕರಿಸಬಹುದಾದ ಸರಕುಪಟ್ಟಿ',
    'Old Invoice Received [Cash]': 'ಹಳೆಯ ಸರಕು ಸ್ವೀಕರಿಸಲಾಗಿದೆ [ನಗದು]',
    'Old Invoice Received [Bank]': 'ಹಳೆಯ ಸರಕುಪಟ್ಟಿ [ಬ್ಯಾಂಕ್] ಸ್ವೀಕರಿಸಲಾಗಿದೆ',    
    'Old Receivable Invoice': 'ಹಳೆಯ ಸ್ವೀಕಾರಾರ್ಹ ಸರಕುಪಟ್ಟಿ',
    'Total Receivable': 'ಒಟ್ಟು ಸ್ವೀಕಾರಾರ್ಹ',
    'Direct Withdrawal': 'ನೇರ ವಿತರಣೆ',
    'Bill Total': 'ಬಿಲ್ ಒಟ್ಟು',
    'Bill Paid [Cash]': 'ಬಿಲ್ ಪಾವತಿ [ನಗದು]',
    'Bill Paid [Bank]': 'ಬಿಲ್ ಪಾವತಿ [ಬ್ಯಾಂಕ್]',
    'Payable Bills': 'ಪಾವತಿಸಬಹುದಾದ ಬಿಲ್ಲುಗಳು',
    'Old Bill Total': 'ಹಳೆಯ ಬಿಲ್ ಒಟ್ಟು',
    'Old Bill Paid [Cash]': 'ಹಳೆಯ ಬಿಲ್ ಪಾವತಿ [ನಗದು]',
    'Old Bill Paid [Bank]': 'ಹಳೆಯ ಬಿಲ್ ಪಾವತಿ [ಬ್ಯಾಂಕ್]',
    'Old Payable Bills': 'ಹಳೆಯ ಪಾವತಿಸಬಹುದಾದ ಬಿಲ್ಗಳು',
    'Total Payable Bills': 'ಒಟ್ಟು ಪಾವತಿಸಬಹುದಾದ ಬಿಲ್ಗಳು',
    'Direct Deposit': 'ನೇರ ಠೇವಣಿ',
    'Old Balance': 'ಹಳೆಯ ಸಮತೋಲನ',
    'Recievable': 'ಸ್ವೀಕಾರಾರ್ಹ',
    'Total Paid': 'ಒಟ್ಟು ಪಾವತಿಸಲಾಗಿದೆ',
    'Donation': 'ಕೊಡುಗೆ',
    'Marriage': 'ಮದುವೆ',
    'Marriage Certificate':'ಮದುವೆ ಪ್ರಮಾಣಪತ್ರ',
    'Certificate' : 'ಪ್ರಮಾಣಪತ್ರ',
    'POS': 'ಪಿಓಎಸ್',
    'Complete Total': 'ಸಂಪೂರ್ಣ ಮೊತ್ತ',
    'Cash': 'ನಗದು',
    'Cash Book': 'ನಗದು ಪುಸ್ತಕ',
    'Day Book': 'ದಿನ ಪುಸ್ತಕ',
    'Consolidated': 'ಕ್ರೋಡಿಕರಿಸು',
    'Agreed':'ಒಪ್ಪಿಗೆ',
    'Mother Name': 'ತಾಯಿಯ ಹೆಸರು',
    'Father Name': 'ತಂದೆಯ ಹೆಸರು',
    'Marriage Date': 'ಮದುವೆ ದಿನಾಂಕ',
    'Age': 'ವಯಸ್ಸು',
    'Sign':'ಚಿಹ್ನೆ',
    'Secretary':'ಕಾರ್ಯದರ್ಶಿ',
    'Place':'ಸ್ಥಳ',
    'Marriage Place':'ಮದುವೆ ಸ್ಥಳ',
    'The marriage of married couple shows that was done according to Hindu custom.':'ಹಿಂದೂ ಸಂಪ್ರದಾಯದ ಪ್ರಕಾರ ಮದುವೆಯಾದ ದಂಪತಿಗಳ ಮದುವೆಯ ಪ್ರದರ್ಶನ.',
    'Bride':'ವಧು',
    'Groom':'ವರ',
    'Voucher No':'ಚೀಟಿ ಸಂಖ್ಯೆ',
    'Excess Amount':'ಹೆಚ್ಚುವರಿ ಮೊತ್ತ',
    'Sale':'ಹುಟ್ಟುವಳಿ',
    'Sale Report':'ಆದಾಯ ವರದಿ',
    'Sale Head':'ಆದಾಯ ಶಿರೋನಾಮೆ'
};
